import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/GridLegacy';

const FitnessPageSkeletonLoading = () => (
	<Grid container spacing={2} data-testid='skeletonLoading'>
		{[0, 1, 2, 3].map(index => (
			<Grid item xs={12} md={6} key={`skeleton-${index}`}>
				<Skeleton variant='rectangle' height={300} />
			</Grid>
		))}
	</Grid>
);

export default FitnessPageSkeletonLoading;
